import React from 'react'
import '../Image/Image.scss';
const Image = () => {
  return (
    <div className='display-wrapper'>
        <div className='display'>
            <img src='https://img.freepik.com/free-photo/close-up-man-doing-crossfit-workout_23-2149080462.jpg?w=900&t=st=1700534558~exp=1700535158~hmac=082a857f67b3475d9d09bc2565209e0c77cea641299362ef83b1978a022dda9a' alt='img'/>
        </div>
    </div>
  )
}

export default Image